import {ShouldRevalidateFunction} from 'react-router-dom'

let forceRevalidate = true

export function markProjectForRevalidation() {
  forceRevalidate = true
}

export const projectRevalidator: ShouldRevalidateFunction = ({
  currentParams,
  nextParams,
  formMethod,
}) => {
  if (formMethod === 'post' || formMethod === 'delete') {
    return true
  }

  if (forceRevalidate) {
    forceRevalidate = false
    return true
  }

  return currentParams.projectId != nextParams.projectId
}
